import { useEffect, useState, useContext } from "react";  
import './../../../index.css'
import systemContext from "../../../_context/systemContext";
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { vscService } from "../../../_services/vscService";
import { FaEdit, FaTrash, FaPlus, FaPercent, FaBuilding } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import PorcentajeModal from "../Modales/ModalPorcentajesAutorizacion";
import '../../../DataTable.css';
import Swal from 'sweetalert2';
import BreadcrumbCatalogos from './BreadcrumbCatalogos';

const PorcentajesAutorizacion = () => {    
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [datos, setDatos] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    // Estados para el modal
    const [showModal, setShowModal] = useState(false);
    const [porcentajeEdit, setPorcentajeEdit] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    // Datos dummy de empresas
    const empresasDummy = [
        { cveCompania: 'F001', descripcion: 'FOOD SERVICE DE MEXICO' },
        { cveCompania: 'P001', descripcion: 'CARNES PREMIUM XO' },
        { cveCompania: 'P002', descripcion: 'ATLANTIC MEAT DE MEXICO' },
        { cveCompania: 'P003', descripcion: 'PRALGO' },
        { cveCompania: 'Q001', descripcion: 'QUALTIA ALIMENTOS OPERACIONES' },
        { cveCompania: 'Q002', descripcion: 'QUALTIA ALIMENTOS OPERACIONES COMERCIALES' }
    ];

    // Opciones fijas para tipo de venta
    const opcionesTipoVenta = [
        { valor: 'Cambio físico', descripcion: 'Cambio físico' },
        { valor: 'Venta sin cargo', descripcion: 'Venta sin cargo' }
    ];

    // Columnas para React Data Table
    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            wrap: true,
            width: '80px'
        },
        {
            name: 'Empresa',
            selector: row => {
                const empresa = empresas.find(emp => emp.cveCompania === row.empresa);
                return empresa ? `${empresa.cveCompania} - ${empresa.descripcion}` : row.cveCompania;
            },
            sortable: true,
            wrap: true,
            minWidth: '300px',
            cell: row => {
                const empresa = empresas.find(emp => emp.cveCompania === row.empresa);
                return (
                    <div className="d-flex align-items-center">
                        <FaBuilding className="text-muted me-2" />
                        <div>
                            <div className="fw-bold">{empresa?.cveCompania || row.cveCompania}</div>
                            <div className="small text-muted">{empresa?.descripcion || 'Empresa no encontrada'}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            name: 'Tipo de Venta',
            selector: row => {
                const tipo = opcionesTipoVenta.find(t => t.valor === row.tipoVenta);
                return tipo ? tipo.descripcion : row.tipoVenta;
            },
            sortable: true,
            wrap: true,
            width: '150px',
        },
        {
            name: 'Porcentaje',
            selector: row => `${(row.porcentaje * 100).toFixed(0)}%`,
            sortable: true,
            wrap: true,
            width: '120px',
            cell: row => (
                <span>
                    {(row.porcentaje * 100).toFixed(0)}%
                </span>
            )
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="nova-grid-actions">
                    <button 
                        className="nova-btn-action nova-btn-edit"
                        onClick={() => handleEdit(row)}
                        data-tooltip-id="edit-tooltip"
                        data-tooltip-content="Editar porcentaje"
                    >
                        <FaEdit className="nova-action-icon" />
                    </button>
                    <button 
                        className="nova-btn-action nova-btn-delete"
                        onClick={() => handleDelete(row.id)}
                        data-tooltip-id="delete-tooltip" 
                        data-tooltip-content="Eliminar porcentaje"
                    >
                        <FaTrash className="nova-action-icon" />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Filtrado de datos
    const filteredItems = datos.filter(item => {
        const empresa = empresas.find(emp => emp.cveCompania === item.empresa);
        const empresaText = empresa ? `${empresa.cveCompania} ${empresa.descripcion}` : '';
        const tipoVenta = opcionesTipoVenta.find(t => t.valor === item.tipoVenta)?.descripcion || '';
        
        return (
            empresaText.toLowerCase().includes(filterText.toLowerCase()) ||
            tipoVenta.toLowerCase().includes(filterText.toLowerCase()) ||
            item.porcentaje?.toString().includes(filterText) ||
            item.id?.toString().includes(filterText)
        );
    });

    // Estilos personalizados para la tabla
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                minHeight: '50px',
                borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
            },
        },
        headCells: {
            style: {
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '0.85rem',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '0.75rem',
                color: 'var(--text-dark)',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '32px',
                '&:nth-child(even)': {
                    backgroundColor: 'rgba(0, 50, 139, 0.02)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 50, 139, 0.05) !important',
                },
            },
            stripedStyle: {
                backgroundColor: 'rgba(0, 50, 139, 0.02)',
            },
        },
        pagination: {
            style: {
                fontSize: '0.7rem',
                borderTop: '1px solid rgba(0, 50, 139, 0.1)',
                color: 'var(--text-dark)',
            },
        },
    };

    // Opciones de paginación en español
    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Componente de búsqueda
    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar por empresa, tipo de venta..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {datos.length} registros
            </div>
        </div>
    );

    // Componente cuando no hay datos
    const NoDataComponent = () => (
        <div className="nova-no-data">
            <div className="nova-no-data-icon">📊</div>
            <h3>No se encontraron porcentajes</h3>
            <p>No hay porcentajes de autorización registrados en el sistema.</p>
            <button className="nova-btn-primary" onClick={handleAddNew}>
                <FaPlus className="me-2" />
                Agregar Primer Porcentaje
            </button>
        </div>
    );

    useEffect(() => {
        getPorcentajes();
        cargarEmpresas();
    }, []);

    const getPorcentajes = async () => {
        try {
            setLoading(true);
            const respuesta = await vscService.getPorcentajes();
            if (respuesta.status === "OK") {
                const datos = respuesta.content.porcentajes || respuesta.content.data || respuesta.data || [];
                setDatos(datos);
            } else {
                throw new Error(respuesta.message || 'Error al cargar porcentajes');
            }
        } catch (error) {
            console.error('Error en obtener porcentajes:', error);
            setDatos([]);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar los porcentajes.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setLoading(false);
        }
    };

    const cargarEmpresas = async () => {
        try {
            // Por ahora usamos datos dummy, pero preparado para API futura
            // const respuesta = await vscService.getEmpresas();
            // if (respuesta.status === "OK") {
            //     setEmpresas(respuesta.content.empresas || respuesta.content.data || []);
            // } else {
            //     // Fallback a datos dummy
            //     setEmpresas(empresasDummy);
            // }
            
            setEmpresas(empresasDummy); // Usar datos dummy por ahora
        } catch (error) {
            console.error('Error al cargar empresas:', error);
            setEmpresas(empresasDummy); // Fallback a datos dummy
        }
    };

    // Handlers
    const handleAddNew = () => {
        setPorcentajeEdit(null);
        setShowModal(true);
    };

    const handleEdit = (porcentaje) => {
        setPorcentajeEdit(porcentaje);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const porcentaje = datos.find(item => item.id === id);
        const empresa = empresas.find(emp => emp.cveCompania === porcentaje?.cveCompania);
        const tipoVenta = opcionesTipoVenta.find(t => t.valor === porcentaje?.tipoVenta);        
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Quieres eliminar el porcentaje para "${empresa?.cveCompania} - ${tipoVenta?.descripcion}"? Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                popup: 'nova-swal-popup',
                confirmButton: 'nova-swal-confirm',
                cancelButton: 'nova-swal-cancel'
            }
        });
        if (result.isConfirmed) {
            setLoading(true);
            try {
                const resultado = await vscService.delEliminaPorcentaje(id);
                if (resultado.statusText === "OK" || resultado.success) {
                    await getPorcentajes();
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Porcentaje eliminado con éxito.",
                        showConfirmButton: false,
                        timer: 1500,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                } else {
                    throw new Error(resultado.message || 'Error al eliminar');
                }
            } catch (error) {
                console.error('Error al eliminar porcentaje:', error);
                await Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: "Error al eliminar el porcentaje.",
                    text: error.message || "Por favor, intenta nuevamente.",
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSavePorcentaje = async (formData) => {
        setModalLoading(true);
        try {
            // Preparar datos según el nuevo formato con empresa
            const porcentajeData = {
                id: porcentajeEdit?.id || 0,
                empresa: formData.cveCompania,
                tipoVenta: formData.tipoVenta,
                porcentaje: parseFloat(formData.porcentaje)
            };
            let resultado;            
            if (porcentajeEdit?.id) {
                // Modo edición
                resultado = await vscService.putEditaPorcentaje(porcentajeData);
            } else {
                // Modo creación
                resultado = await vscService.postInsertaPorcentaje(porcentajeData);
            }
            if (resultado.status === "OK" || resultado.success) {
                await getPorcentajes();
                setShowModal(false);
                setPorcentajeEdit(null);
                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: porcentajeEdit?.id ? "Porcentaje actualizado con éxito." : "Porcentaje creado con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }
        } catch (error) {
            console.error('Error al guardar porcentaje:', error);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al guardar el porcentaje.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setModalLoading(false);
        }
    };

    return (
        <div className="nova-dashboard-balanced">
            {/* Header de la página */}
            <div className="nova-page-header">
                <h3 className="nova-page-title">Porcentajes de Autorización</h3>
                <div className="nova-header-actions-right">
                    <BreadcrumbCatalogos />
                    <button 
                        className="nova-btn-primary"
                        onClick={handleAddNew}
                    >
                        <FaPlus className="me-2" />
                        Agregar Nuevo Porcentaje
                    </button>
                </div>
            </div>
            {/* Contenedor de la tabla */}
            <div className="nova-data-table-container">
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    className="nova-react-datatable"
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50]}
                    paginationComponentOptions={paginationComponentOptions}
                    progressPending={loading}
                    progressComponent={
                        <div className="nova-grid-loading">
                            <Spinner animation="border" role="status" />
                            <p>Cargando porcentajes...</p>
                        </div>
                    }
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    noDataComponent={<NoDataComponent />}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="700px"
                    persistTableHead
                />
            </div>
            {/* Modal para crear/editar */}
            <PorcentajeModal
                show={showModal}
                onHide={() => setShowModal(false)}
                porcentaje={porcentajeEdit}
                empresas={empresas}
                opcionesTipoVenta={opcionesTipoVenta}
                onSave={handleSavePorcentaje}
                loading={modalLoading}
            />
            {/* Tooltips */}
            <Tooltip id="edit-tooltip" place="top" />
            <Tooltip id="delete-tooltip" place="top" />
        </div>
    );
};

export default PorcentajesAutorizacion;